import { Connection } from '@3d-scene/model3d/connection';

export class ConnectionProjectData {

  public connectionCubes: Connection[] = [];
}
